import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api"
import React, { useState, useEffect } from "react"
import { SaveButton } from "./Buttons"
import { URL_PATHS } from "constants/index"

const MapComponent = ({ markers, history }) => {
  const [infoWindow, setInfowindow] = useState()
  const [mapRef, setMapRef] = useState(null)

  const handleOnLoad = map => {
    setMapRef(map)
  }

  const fitBounds = markers => {
    const bounds = new google.maps.LatLngBounds()
    if (markers?.length) {
      markers?.map(item => {
        bounds.extend({ lat: item?.lat, lng: item?.lon })
        return item.id
      })
      mapRef.fitBounds(bounds)
    }
  }

  useEffect(() => {
    if (mapRef && markers) {
      fitBounds(markers)
      setInfowindow(null)
    }
  }, [markers, mapRef])

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "500px" }}
      center={{ lat: 40.854885, lng: -88.081807 }}
      zoom={4}
      onLoad={handleOnLoad}
    >
      {markers?.map(place => (
        <Marker
          key={place?.id}
          position={{ lat: place?.lat, lng: place?.lon }}
          onClick={() => setInfowindow(place.id)}
        >
          {infoWindow === place?.id && (
            <InfoWindow onCloseClick={() => setInfowindow(null)}>
              <div className="p-1">
                {place?.category && (
                  <p style={{ borderBottom: "1px solid black" }}>
                    {place?.category?.name}
                  </p>
                )}
                <h4>{place?.name}</h4>
                <p>{place?.address}</p>
                <p>{place?.hours}</p>
                {place?.details && <p>Notes: {place?.details}</p>}
                <div className="d-flex justify-content-center">
                  <SaveButton
                    type="button"
                    content="Update"
                    color="light"
                    onClick={() =>
                      history?.push(`${URL_PATHS.PLACES}/${place?.id}`)
                    }
                  />
                </div>
              </div>
            </InfoWindow>
          )}
        </Marker>
      ))}
    </GoogleMap>
  )
}

export default React.memo(MapComponent)
